import React from 'react';
import classnames from 'classnames';
import styles from "./text.module.css";
const baseClass = 'text';
export const Text = ({ children, className, tag = 'p', id, variant = 'paragraph-100', withShadow }) => {
    const classes = classnames(styles.text, styles[`${baseClass}--${variant}`], { [styles[`${baseClass}--${variant}--with-shadow`]]: withShadow }, className);
    const Tag = tag;
    return (React.createElement(Tag, { className: classes, id: id }, children));
};
//# sourceMappingURL=index.js.map